import ContextSingleton from '../__singletons__/context-singleton';

const useContextApi = () => {
  const context = ContextSingleton.getInstance();
  if (!context.api) throw new Error('API not found');
  return { api: context.api, features: context.features };
};

export default useContextApi;
